import { render, staticRenderFns } from "./mediaVideo.vue?vue&type=template&id=1ee64d1b&scoped=true&"
import script from "./mediaVideo.vue?vue&type=script&lang=js&"
export * from "./mediaVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee64d1b",
  null
  
)

export default component.exports